import { toFlatField } from '../oasis-types';
export const PlanOfCareVersioned = {
    planOfCare: { e1: { alias: 'planOfCare', timepoint: ['*'] } },
};
export const PlanOfCare = toFlatField(PlanOfCareVersioned);
